<template>
<div>
    <app-layout >
        <template #header>
            <h2 class="h4 font-weight-bold">
                Configuration
            </h2>
        </template>
              <div v-if="$page.props.flash.message">
                        <div class="alert alert-success" >
                        {{ $page.props.flash.message }}
                        </div>
                </div>
                <div class="shadow-sm p-4 table-responsive">
                    <button @click="openModal()" class="btn btn-secondary mb-3">Create New Config</button>
                   
                    <table class="table table-bordered">
                        <thead>
                            <tr class="bg-primary text-white ">
                                <th class="px-4 py-2">Section</th>
                                <th class="px-4 py-2">Title</th>
                                <th class="px-4 py-2">Remark</th>
                                <th class="px-4 py-2">Type</th>
                                <th class="px-4 py-2">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="config.length">
                            <tr v-for="row in config" :key="row.id" >
                                <td >{{ row.section }}</td>
                                <td >{{ row.title }}</td>
                                <td>{{ row.remark }}</td>
                                <td>{{ row.type }}</td>
                                <td >
                                    <button @click="edit(row)" class="btn btn-secondary btn-sm mr-1">Edit</button> 
                                    <button @click="deleteRow(row)" class="btn btn-danger btn-sm">x</button>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="6">No data</td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="modal fade " ref="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"  data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content" >
                            <div class="modal-header border-bottom-0">
                                <h5 class="modal-title" id="exampleModalLabel">Create Config</h5>
                                <button type="button" class="close" @click="closeModal()" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <form v-if="isOpen">
                            <div class="modal-body"  >
                                <div class="form-group">
                                    <label>Section</label>
                                    <input type="text" class="form-control"  v-model="form.section">
                                    <div v-if="$page.props.errors.section" class="text-danger">{{ $page.props.errors.section }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Title</label>
                                    <input type="text" class="form-control" v-model="form.title">
                                    <div v-if="$page.props.errors.title" class="text-danger">{{ $page.props.errors.title }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Remark</label>
                                    <textarea  class="form-control"  v-model="form.remark" ></textarea>
                                    <div v-if="$page.props.errors.remark" class="text-danger">{{ $page.props.errors.remark }}</div>
                                </div>

                                <div class="form-group">
                                    <label>Value</label>
                                    <textarea  class="form-control" v-model="form.value">
                                    </textarea>
                                    <div v-if="$page.props.errors.value" class="text-danger">{{ $page.props.errors.value }}</div>
                                </div>

                           
                                <div class="form-group">
                                    <label>Type</label>
                                    <select class="form-control"  v-model="form.type">
                                        <option>string</option>
                                        <option>longtext</option>
                                        <option>editor</option>
                                        <option>image</option>
                                    </select>
                                    <div v-if="$page.props.errors.type" class="text-danger">{{ $page.props.errors.type }}</div>
                                </div>


                            </div>
                                <div class="modal-footer border-top-0 d-flex justify-content-center">
                                <button wire:click.prevent="store()" type="button" class="btn btn-success" v-show="!editMode" @click="save(form)">
                                    Save
                                </button>

                                <button wire:click.prevent="store()" type="button" class="btn btn-success" v-show="editMode" @click="update(form)">
                                    Update
                                </button>

                                    <button @click="closeModal()" type="button" class="btn btn-danger">
                                    Cancel
                                </button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>

                    <paginator/>

                </div>

    </app-layout>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import Paginator from '@/Layouts/Paginator.vue'

export default {
  components: {
    AppLayout,
    Paginator
  },

  props: ['config','errors'],
  data() {
            return {
                editMode: false,
                isOpen: false,
                form: {
                    section: null,
                    title: null,
                    remark: null,
                    type: "String",
                    value: null,
                },
            }
        },
        methods: {
            openModal: function () {
                this.isOpen = true;
                let element = this.$refs.modal
                $(element).modal('show')
            },
            closeModal: function () {
                let element = this.$refs.modal
                $(element).modal('hide')
                this.editMode=false;
                this.reset();
            },
            reset: function () {
                this.form = {
                    section: null,
                    title: null,
                    remark: null,
                    type: null,
                    value: null,
                }
            },
            save: function (data) {
                this.$inertia.post('/admin/config/action/', data, {
                    onSuccess: page => {
                        this.editMode = false;
                        this.reset();
                        this.closeModal();
                    },
                })   
                
            },
            edit: function (data) {
                this.form = Object.assign({}, data);
                this.editMode = true;
                this.openModal();
            },
            update: function (data) {
                data._method = 'PUT';
                this.$inertia.post('/admin/config/action/' + data.id, data,{
                     preserveScroll:true,
                    onSuccess: page => {
                        this.reset();
                        this.closeModal();
                    },
                })
                
            },
            deleteRow: function (data) {
                if (!confirm('Are you sure want to remove?')) return;
                data._method = 'DELETE';
                this.$inertia.post('/admin/config/action/' + data.id, data,{
                     preserveScroll:true
                })
                this.reset();
                this.closeModal();
            }
        }

}
</script>
